<template>
  <div class="navbar-brand">
    <img src="../../../../assets/images/logo-white.png" alt="" key="0" />
    <span style="vertical-align: middle;">培训管理系统</span>
  </div>
</template>

<script>
export default {
  name: 'logo',
  data() {
    return {}
  }
}
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar/logo.vue